import { render, staticRenderFns } from "./InvitationCard.vue?vue&type=template&id=2d022c82&scoped=true&"
import script from "./InvitationCard.vue?vue&type=script&lang=js&"
export * from "./InvitationCard.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCard.vue?vue&type=style&index=0&id=2d022c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d022c82",
  null
  
)

export default component.exports